// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.z7zFEHctOZnqaMuRn69L {
  position: fixed;
  top: 0;
  left: 0;
  display: block;
  width: 100%;
  height: calc(50vh + 13px) !important;
  padding-top: calc(50vh - 13px);
  text-align: center;
  background: #f7f7f7;
}

.NHq_3VxL44eDuAZOw52p {
  display: block;
  width: 100%;
  height: 100%;
  text-align: center;
}

.eK6NlGg8TDxg2ujpcsOp {
  background: #490c4e !important;
}`, "",{"version":3,"sources":["webpack://./js/view/component/loader/style.scss","webpack://./scss/_variables.scss"],"names":[],"mappings":"AAEA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,cAAA;EACA,WAAA;EACA,oCAAA;EACA,8BAAA;EACA,kBAAA;EACA,mBCRQ;ADOV;;AAIA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AADF;;AAIA;EACE,8BAAA;AADF","sourcesContent":["@import '~scss/variables';\n\n.fullscreen {\n  position: fixed;\n  top: 0;\n  left: 0;\n  display: block;\n  width: 100%;\n  height: calc(50vh + 13px) !important;\n  padding-top: calc(50vh - 13px);\n  text-align: center;\n  background: $body-bg;\n}\n\n.loader {\n  display: block;\n  width: 100%;\n  height: 100%;\n  text-align: center;\n}\n\n.bg_purple {\n  background: #490c4e !important;\n}\n","\n// Colours\n$black: #0000;\n$body-bg: #f7f7f7;\n$h-purple: #37003c;\n$bg-header: #37023b;\n\n$pink-theme-h: #910c45;\n$pink-theme-start: #fd2982;\n$pink-theme-end: #910c45;\n\n$blue-theme-h: #0c4693;\n$blue-theme-start: #29d4fd;\n$blue-theme-end: #0c4591;\n\n$green-theme-h: #0f932e;\n$green-theme-start: #29fd5a;\n$green-theme-end: #0c912c;\n\n$orange-theme-h: #f06f2a;\n$orange-theme-start: #fdb429;\n$orange-theme-end: #f47000;\n\n// Fonts\n$pl-regular: 'PremierLeague-Regular', serif;\n$pl-bold: 'PremierLeague-Bold', serif;\n$pl-bold-italic: 'PremierLeague-BoldItalic', serif;\n$pl-light: 'PremierLeague-Light', serif;\n\n// Spacing\n$spacing-25: 25px;\n\n// Background\n$login-bg: url('../asset/img/login_bg@2x.png');\n\n$min-contrast-ratio:   0.5 !default;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fullscreen": `z7zFEHctOZnqaMuRn69L`,
	"loader": `NHq_3VxL44eDuAZOw52p`,
	"bg_purple": `eK6NlGg8TDxg2ujpcsOp`
};
export default ___CSS_LOADER_EXPORT___;
